import React from "react";

/**
 * CardStatTipoTicket Component
 * Displays statistics for a specific ticket type including sales by gender
 * 
 * @param {Object} props
 * @param {string} props.ticketTypeName - Name of the ticket type
 * @param {string} props.imgEvento - Event image URL from S3
 * @param {string} props.imgTypeTicket - Ticket type specific image URL from S3
 * @param {number} props.precioVenta - Sale price
 * @param {number} props.totalTicketsPuestosEnVenta - Total tickets available for sale
 * @param {number} props.totalDeTicketsComprados - Total tickets purchased
 * @param {number} props.totalTicketsCompradosPorHombres - Tickets purchased by men
 * @param {number} props.totalTicketsCompradosPorMujeres - Tickets purchased by women
 * @param {number} props.totalTicketsCompradosPorOtros - Tickets purchased by others
 */
const CardStatTipoTicket = ({
  ticketTypeName = "",
  imgEvento = null,
  imgTypeTicket = null,
  precioVenta = 0,
  totalTicketsPuestosEnVenta = 0,
  totalDeTicketsComprados = 0,
  totalTicketsCompradosPorHombres = 0,
  totalTicketsCompradosPorMujeres = 0,
  totalTicketsCompradosPorOtros = 0,
}) => {
  // Calculate percentage sold
  const porcentajeVendido = totalTicketsPuestosEnVenta > 0
    ? ((totalDeTicketsComprados / totalTicketsPuestosEnVenta) * 100).toFixed(1)
    : 0;

  // Determine which image to use (prioritize ticket type image, fallback to event image, then null)
  const displayImage = imgTypeTicket || imgEvento || null;

  return (
    <div className="flex flex-row items-center justify-center bg-aw-bluedark-85 border border-aw-green-75 rounded-lg p-4">
      {/* Image Section */}
      <img
        src={displayImage || "/placeholder-ticket.png"}
        alt={ticketTypeName}
        className="w-3/12 h-24 object-cover rounded-2xl border border-gray-600 mr-4"
      />

      {/* Info Section */}
      <div className="w-8/12 pl-2">
        <h4 className="text-lg font-semibold text-white line-clamp-1">
          Ticket - {ticketTypeName}
        </h4>
        <hr className="border-gray-600 my-2" />

        {/* Precio */}
        <p className="text-sm text-gray-300">
          <span className="text-white font-semibold">Precio:</span> $
          {precioVenta.toLocaleString()} por persona
        </p>

        {/* Tickets en Venta */}
        <p className="text-sm text-gray-300">
          <span className="text-aw-green font-semibold">
            {totalTicketsPuestosEnVenta.toLocaleString()}
          </span>{" "}
          Tickets a la Venta
        </p>

        <hr className="border-gray-600 my-2" />

        {/* Total Vendidos */}
        <p className="text-sm text-aw-bluedark bg-aw-green mb-1 px-2 py-1 rounded-full">
          <span className="font-semibold">Vendidos: </span>
          {totalDeTicketsComprados.toLocaleString()} ({porcentajeVendido}%)
        </p>

        {/* Hombres */}
        <p className="text-sm text-white bg-blue-600 mb-1 px-2 py-1 rounded-full">
          <span className="font-semibold">Hombres: </span>
          {totalTicketsCompradosPorHombres.toLocaleString()} Tickets
        </p>

        {/* Mujeres */}
        <p className="text-sm text-white bg-pink-600 mb-1 px-2 py-1 rounded-full">
          <span className="font-semibold">Mujeres: </span>
          {totalTicketsCompradosPorMujeres.toLocaleString()} Tickets
        </p>

        {/* Otros */}
        <p className="text-sm text-aw-bluedark bg-white mb-1 px-2 py-1 rounded-full">
          <span className="font-semibold">Otros: </span>
          {totalTicketsCompradosPorOtros.toLocaleString()} Tickets
        </p>
      </div>
    </div>
  );
};

export default CardStatTipoTicket;
